import { SapMasterProducts } from "../../features"

const SapMasterProductsPage = () => {
  return <SapMasterProducts />
}

export default SapMasterProductsPage
